export class VariableData {
  name: string;
  category: string;
  description: string;
  value: string;
}
